import MuiDrawer, { DrawerProps } from "@mui/material/Drawer";

const Drawer = (props: DrawerProps) => (
  <MuiDrawer
    slotProps={{
      backdrop: {
        sx: {
          backdropFilter: "blur(2px)",
        },
      },
    }}
    {...props}
  />
);

export default Drawer;
